module.exports = __webpack_public_path__ + "static/media/test1.902b473f.png";